<template>
  <ATooltip placement="right" :delay="{ show: 10, hide: 0 }">
    <div class="block-lease">
      <NavBarButton
        :class="{ active: !!leaseBlockedUntil }"
        class="block-lease-button"
        data-test-id="block-lease-button"
        @click="click"
      >
        <TimeIcon16 data-test-id="block-lease-icon" />
        <template #title>
          {{
            $t(leaseBlockedUntil ? 'licensing.blockLeaseButton.unblockTitle' : 'licensing.blockLeaseButton.blockTitle')
          }}
        </template>
      </NavBarButton>
    </div>
    <template #popper>
      <div data-test-id="blocked-lease-tooltip" v-html="tooltipText" />
    </template>
  </ATooltip>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters, mapState } from 'vuex';
import { getLeaseManager } from '@/license';
import TimeIcon16 from '@components/Icons/TimeIcon16.vue';
import NavBarButton from '@components/NavBar/NavBarButton.vue';

export default defineComponent({
  name: 'BlockLeaseButton',

  components: {
    TimeIcon16,
    NavBarButton,
  },

  methods: {
    click() {
      const leaseManager = getLeaseManager(this.$store);

      if (this.leaseBlockedUntil) {
        leaseManager.unblockLease();
      } else {
        leaseManager.blockLease(14 * 24 * 60);
      }
    },
  },

  computed: {
    ...mapState('user', ['lease']),
    ...mapGetters('user', ['leaseBlockedUntil']),

    tooltipText(): string {
      if (this.leaseBlockedUntil) {
        const date = new Date(this.leaseBlockedUntil);

        return this.$t('licensing.blockLeaseButton.unblockAction.text', { untilDate: this.$d(date, 'short') });
      }

      return this.$t('licensing.blockLeaseButton.blockAction.text');
    },
  },
});
</script>

<style lang="scss">
@use 'settings/colors';

.block-lease-button {
  &.active {
    color: colors.$color-blue;
    background: colors.$color-blue-100;
  }
}
</style>
